<template>
  <div class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Menu - Zápatí - Upravit <span class="text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <h4 class="text-black mt-4 mb-3"><strong>Nastavitelné podle jazyka</strong></h4>
        <a-form-item
          label="Nadpis v menu"
          :validate-status="error('mle_menu_title') ? 'error' : ''"
          :help="error('mle_menu_title') || ''"
        >
          <a-input placeholder="Nadpis v menu" v-decorator="['mle_menu_title', {rules: [{required: true, message: 'Nadpis v menu musí být vyplněn!'},{max: 60, message: 'Nadpis v menu nemůže být delší než 60 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Nadpis v prohlížeči"
          :validate-status="error('mle_head_title') ? 'error' : ''"
          :help="error('mle_head_title') || ''"
        >
          <a-input placeholder="Nadpis v prohlížeči" v-decorator="['mle_head_title', {rules: [{max: 50, message: 'Nadpis v prohlížeči nemůže být delší než 50 znaků!'}, {required: true, message: 'Nadpis v prohlížeči musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          :validate-status="error('mle_meta_description') ? 'error' : ''"
          :help="error('mle_meta_description') || ''"
        >
          <span slot="label">
            Meta description&nbsp;
            <a-tooltip title="Popisek stránky pro vyhledávač">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-input type="textarea" placeholder="Meta description" v-decorator="['mle_meta_description', {rules: [{max: 160, message: 'Meta description nemůže být delší než 160 znaků!'}, {required: true, message: 'Meta description musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="Meta keywords"
          :validate-status="error('meta_keywords') ? 'error' : ''"
          :help="error('meta_keywords') || ''"
        >
          <a-select placeholder="-- Vyber meta keywords --" :loading="item.meta_keywords.loading" mode="tags" :options="metaKeywords.map(x => { return { value: x.mkd_id.toString(), label: x.languages.length > 0 ? '# ' + x.mkd_id + ' | ' + x.languages[0].pivot.mkd_name : '# ' + x.mkd_id + ' | není nastaveno' } })" v-decorator="['meta_keywords', {rules: [{required: true, message: 'Meta keywords musí být vyplněn!'}]}]"></a-select>
        </a-form-item>

        <a-form-item
          label="Nadpis stránky u článku"
          :validate-status="error('mle_article_title') ? 'error' : ''"
          :help="error('mle_article_title') || ''"
        >
          <a-input placeholder="Nadpis stránky u článku" v-decorator="['mle_article_title', {rules: [{max: 120, message: 'Nadpis stránky u článku nemůže být delší než 120 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item label="Zveřejnit?">
          <a-checkbox v-decorator="['mle_is_active', { valuePropName: 'checked', initialValue: true }]"/>
        </a-form-item>

        <h4 class="text-black mt-4 mb-3"><strong>Ostatní</strong></h4>

        <a-form-item
          label="Vyber kategorii zápatí"
          :validate-status="error('mfe_id') ? 'error' : ''"
          :help="error('mfe_id') || ''"
        >
          <a-select placeholder="-- Vyber kategorii zápatí --" :loading="item.mfe_id.loading" :options="menuFooterTitles.map(x => { return { value: x.mfe_id, label: x.languages.length > 0 ? '# ' + x.mfe_id + ' | ' + x.languages[0].pivot.mfe_title : '# ' + x.mfe_id + ' | není nastaveno' } })" v-decorator="['mfe_id', {rules: [{required: true, message: 'Kategorie zápatí musí být vyplněn!'}]}]"></a-select>
        </a-form-item>

        <a-form-item
          label="Vyber články"
        >
          <a-select :disabled="this.form.getFieldValue('meu_is_blog') || this.form.getFieldValue('meu_is_ecommerce')" placeholder="-- Vyber články --" :loading="item.articles.loading" mode="multiple" v-decorator="['articles']">
            <a-select-opt-group v-for="articleGroup in articleGroups" :label="getType(articleGroup.ate_type)" :key="articleGroup.ate_id">
              <a-select-option :key="article.ate_id" v-for="article in getArticlesByType(articleGroup.ate_type)" :value="article.ate_id">{{ article.languages.length > 0 ? '# ' + article.ate_id + ' | ' + article.languages[0].pivot.ale_name : '# ' + article.ate_id + ' | ' + 'není nastaveno' }}</a-select-option>
            </a-select-opt-group>
          </a-select>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Úvod&nbsp;
            <a-tooltip title="Úvodní stránka">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-checkbox :disabled="this.form.getFieldValue('articles') === undefined || this.form.getFieldValue('articles').length === 0" v-decorator="['meu_is_home', { valuePropName: 'checked', initialValue: false }]"/>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            E-shop&nbsp;
            <a-tooltip title="Hlavní stránka e-shopu">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-checkbox :disabled="this.form.getFieldValue('meu_is_blog') || (this.form.getFieldValue('articles') !== undefined && this.form.getFieldValue('articles').length > 0)" v-decorator="['meu_is_ecommerce', { valuePropName: 'checked', initialValue: false }]"/>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Blog&nbsp;
            <a-tooltip title="Hlavní stránka blogu">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <a-checkbox :disabled="this.form.getFieldValue('meu_is_ecommerce') || (this.form.getFieldValue('articles') !== undefined && this.form.getFieldValue('articles').length > 0)" v-decorator="['meu_is_blog', { valuePropName: 'checked', initialValue: false }]"/>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '@/services/forms'

function typeOfNaN(x) {
  return Number.isNaN(x) || isNaN(x)
}

export default {
  components: { ActionTools, LanguageTab },
  beforeCreate() {
    this.form = this.$form.createForm(this, {
      onFieldsChange: (props, fields) => {
        const key = Object.keys(fields)[0]
        if (this.checkboxes.includes(key)) {
          this.changeCheckbox(fields, key)
        }
        if (key === 'articles' && this.form.getFieldValue('articles').length === 0) {
          this.form.setFieldsValue({
            meu_is_home: false,
          })
        }
      },
    })
  },
  data: function () {
    return {
      hasErrors,
      dependencies: ['meta_keywords', 'articles', 'mfe_id'],
      id: this.$route.params.id,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/menu/footer',
          title: 'Seznam',
        },
      ],
      checkboxes: ['meu_is_home', 'meu_is_ecommerce', 'meu_is_blog'],
      selectedMeuId: false,
      item: {
        mfe_id: {
          loading: false,
          active: undefined,
        },
        articles: {
          loading: false,
          active: [],
        },
        meta_keywords: {
          loading: false,
          active: [],
        },
        meu_is_ecommerce: false,
        meu_is_blog: false,
        meu_is_home: false,
        menu_languages: [],
      },
      loaded: [],
    }
  },
  computed: {
    articleGroups: function () {
      return this.articles.filter(
        (thing, i, arr) => arr.findIndex(t => t.ate_type === thing.ate_type) === i,
      )
    },
    language: function() {
      return this.$store.getters['language/active']
    },
    detail: function() {
      return this.$store.getters['menuFooter/getDetail']
    },
    metaKeywords: function() {
      return this.$store.getters['metaKeyword/currentLanguage']('')
    },
    menuFooterTitles: function() {
      return this.$store.getters['menuFooterTitle/currentLanguageOnly']
    },
    articles: function() {
      return this.$store.getters['article/currentLanguage']('')
    },
    menuMainOnly: function() {
      return this.$store.getters['menuMain/currentLanguageOnly']
    },
  },
  methods: {
    getArticlesByType(type) {
      return this.articles.filter(x => x.ate_type === type)
    },
    getType(type) {
      const typeObj = this.$store.getters['article/getTypes'](type)
      return typeObj && typeObj.title ? typeObj.title : 'Ostatní'
    },
    initData() {
      this.loading = true
      this.dependencies.forEach((value) => {
        this.item[value].loading = true
      })
      Promise.all([
        this.$store.dispatch('metaKeyword/getList'),
        this.$store.dispatch('article/getAll'),
        this.$store.dispatch('menuFooterTitle/getOnly'),
        this.$store.dispatch('menuMain/getOnly'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          this.dependencies.forEach((value) => {
            this.item[value].loading = false
          })
          this.loaded.push(this.language)
        })
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('menuFooter/getOne', this.id)
        .then(() => {
          const oldItem = this.item
          this.item = Object.assign({}, this.detail)
          this.item.articles = {
            loading: false,
            active: oldItem.articles.active.length > 0 ? oldItem.articles.active : Array.from(this.detail.articles),
          }
          this.item.meta_keywords = {
            loading: false,
            active: oldItem.meta_keywords.active,
          }
          this.item.mfe_id = {
            loading: false,
            active: oldItem.mfe_id.active !== undefined ? oldItem.mfe_id.active : this.detail.mfe_id,
          }
          this.item.meta_keywords.active.push({
            lge_id: this.language,
            items: [],
          })
          const currentDetailLang = this.$store.getters['menuFooter/currentLanguageDetail']
          this.form.setFieldsValue({
            mle_is_active: currentDetailLang.mle_is_active,
            mle_meta_description: currentDetailLang.mle_meta_description,
            mle_article_title: currentDetailLang.mle_article_title,
            mle_head_title: currentDetailLang.mle_head_title,
            mle_menu_title: currentDetailLang.mle_menu_title,
            mfe_id: this.item.mfe_id.active,
            meta_keywords: this.detail.meta_keywords,
            articles: this.item.articles.active,
            meu_is_home: this.item.meu_is_home,
            meu_is_ecommerce: this.item.meu_is_ecommerce,
            meu_is_blog: this.item.meu_is_blog,
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    changeCheckbox(fieldData, fieldName) {
      if (this.form.getFieldValue(fieldName)) {
        this.checkboxes.forEach((x) => {
          if (x === fieldName) { return false }
          this.form.setFieldsValue({
            [x]: false,
          })
        })
      }
    },
    getData() {
      const metaKeywords = []
      if (this.form.getFieldValue('meta_keywords') !== undefined) {
        this.form.getFieldValue('meta_keywords').forEach(x => {
          if (!typeOfNaN(x) && this.metaKeywords.find(y => y.mkd_id === parseInt(x))) {
            metaKeywords.push(parseInt(x))
          }
        })
      }
      const menuLanguages = this.item.menu_languages.filter(x => x.mle_meta_description !== undefined && x.mle_meta_description.trim().length > 0 && x.mle_head_title !== undefined && x.mle_head_title.trim().length > 0 && x.mle_menu_title !== undefined && x.mle_menu_title.trim().length > 0)
      menuLanguages.forEach((value, key) => {
        if (value.mle_article_title === undefined) {
          menuLanguages[key].mle_article_title = null
        }
        value.url = this.$store.getters['language/getById'](value.lge_id).url
      })
      return {
        meu_id: null,
        mfe_id: this.form.getFieldValue('mfe_id') === undefined ? null : parseInt(this.form.getFieldValue('mfe_id')),
        meu_is_active: true,
        articles: this.form.getFieldValue('articles') === undefined ? [] : this.form.getFieldValue('articles').map((x, index) => { return { ate_id: parseInt(x), mae_position: index + 1 } }),
        meu_is_ecommerce: this.form.getFieldValue('meu_is_ecommerce'),
        meu_is_blog: this.form.getFieldValue('meu_is_blog'),
        meu_is_home: this.form.getFieldValue('meu_is_home'),
        menu_languages: menuLanguages,
        meta_keywords: {
          new: {
            count: this.item.meta_keywords.active[0].items.length,
            languages: this.item.meta_keywords.active[0].items.length === 0 ? [] : this.item.meta_keywords.active,
          },
          existing: metaKeywords,
        },
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('menuFooter/put', { id: this.id, item: this.getData() })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    handleChange(oldLanguage) {
      const foundObj = { menu: false, meta: false }
      const newObj = {
        menu: {
          lge_id: oldLanguage,
          mle_menu_title: this.form.getFieldValue('mle_menu_title'),
          mle_is_active: this.form.getFieldValue('mle_is_active'),
          mle_meta_description: this.form.getFieldValue('mle_meta_description'),
          mle_article_title: this.form.getFieldValue('mle_article_title'),
          mle_head_title: this.form.getFieldValue('mle_head_title'),
        },
        meta: {
          lge_id: oldLanguage,
          items: this.form.getFieldValue('meta_keywords') === undefined ? [] : this.form.getFieldValue('meta_keywords').filter(x => { return !(!typeOfNaN(x) && this.metaKeywords.find(y => y.mkd_id === parseInt(x))) }),
        },
      }
      this.item.menu_languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.menu_languages[key] = newObj.menu
          foundObj.menu = true
          return true
        }
      })
      this.item.meta_keywords.active.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.meta_keywords.active[key] = newObj.meta
          foundObj.meta = true
          return true
        }
      })
      if (!foundObj.menu) {
        this.item.menu_languages.push(newObj.menu)
      }
      if (!foundObj.meta) {
        this.item.meta_keywords.active.push(newObj.meta)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    refreshComponent(id) {
      this.id = id
      this.selectedMeuId = false
      this.item = {
        mfe_id: {
          loading: false,
          active: undefined,
        },
        articles: {
          loading: false,
          active: [],
        },
        meta_keywords: {
          loading: false,
          active: [],
        },
        meu_is_ecommerce: false,
        meu_is_blog: false,
        meu_is_home: false,
        menu_languages: [],
      }
      this.loaded = []
    },
  },
  created() {
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.initData()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null && this.loaded.includes(oldValue)) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        if (!this.loaded.includes(this.language)) {
          this.initData()
        } else {
          const foundObj = { menu: this.item.menu_languages.find(x => x.lge_id === newValue), meta: this.item.meta_keywords.active.find(x => x.lge_id === newValue) }
          let newObj
          if (foundObj.menu === undefined) {
            newObj = {
              mle_is_active: true,
              mle_meta_description: undefined,
              mle_article_title: undefined,
              mle_head_title: undefined,
              mle_menu_title: undefined,
            }
          } else {
            newObj = {
              mle_is_active: foundObj.menu.mle_is_active,
              mle_meta_description: foundObj.menu.mle_meta_description,
              mle_article_title: foundObj.menu.mle_article_title,
              mle_head_title: foundObj.menu.mle_head_title,
              mle_menu_title: foundObj.menu.mle_menu_title,
            }
            newObj.meta_keywords = this.form.getFieldValue('meta_keywords') === undefined ? [] : this.form.getFieldValue('meta_keywords').filter(x => { return !typeOfNaN(x) && this.metaKeywords.find(y => y.mkd_id === parseInt(x)) })
            if (foundObj.meta === undefined) {
              if (oldValue !== null) {
                const lastLangMetaKeywords = this.item.meta_keywords.active.find(x => x.lge_id === oldValue).items
                if (lastLangMetaKeywords !== undefined) {
                  newObj.meta_keywords = newObj.meta_keywords.concat(lastLangMetaKeywords)
                }
              }
            } else {
              newObj.meta_keywords = newObj.meta_keywords.concat(foundObj.meta.items)
            }
            newObj.meta_keywords = newObj.meta_keywords.filter((item, index) => newObj.meta_keywords.indexOf(item) === index)
          }
          this.form.setFieldsValue(newObj)
        }
        this.form.validateFields()
      }
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.initDetail()
      }
    },
  },
}
</script>
